import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import CitiesListPage from '../components/CitiesListPage'
import {
  actionCreators,
  ICitiesListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectScope,
  selectSortOrder,
  selectTotalItems,
} from '../modules/citiesList'

export default connect(
  createStructuredSelector<ApplicationState, ICitiesListState>({
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    scope: selectScope(),
    sortOrder: selectSortOrder(),
    totalItems: selectTotalItems(),
  }),
  actionCreators,
)(CitiesListPage)
